import { render } from "./ProcessScreenNew.vue?vue&type=template&id=36841f21&scoped=true"
import script from "./ProcessScreenNew.vue?vue&type=script&lang=js"
export * from "./ProcessScreenNew.vue?vue&type=script&lang=js"

import "./ProcessScreenNew.vue?vue&type=style&index=0&id=36841f21&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36841f21"]])

export default __exports__